import { Modal } from 'antd';
import { FC } from 'react';

import IssuePanel, { IssuePanelProps } from 'src/atomic-components/organisms/IssuePanel/IssuePanel';

/**
 * IssuePanelModal에서 사용하는 데이터 타입
 * - IssuePanelProps와 동일하지만 null을 허용
 */
export type IssuePanelModalData = IssuePanelProps | null;

type IssuePanelModalProps = IssuePanelProps & {
  open: boolean;
  onClose: () => void;
};

const IssuePanelModal: FC<IssuePanelModalProps> = ({ open, onClose, ...issuePanelProps }) => {
  return (
    <Modal
      title='이슈 패널'
      open={open}
      onCancel={onClose}
      footer={null}
      width={1200}
      styles={{
        header: {
          backgroundColor: '#f6f7f9',
          borderBottom: '1px solid #e8e8e8',
          marginBottom: 0,
          paddingBottom: 12,
        },
        body: {
          height: 'calc(100vh - 200px)',
          display: 'flex',
        },
        content: {
          padding: '20px 40px',
          backgroundColor: '#f6f7f9',
        },
      }}
      centered>
      <IssuePanel {...issuePanelProps} />
    </Modal>
  );
};

export default IssuePanelModal;
